import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home/index'
import brand from '@/view/brand/index'
import join from '@/view/join/index'
import store from '@/view/store/index'
import connect from '@/view/connect/index'
import information from '@/view/information/index'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/brand',
      name: 'brand',
      component: brand
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/store',
      name: 'store',
      component: store
    },
    {
      path: '/connect',
      name: 'connect',
      component: connect
    },
    {
      path: '/information',
      name: 'information',
      component: information
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (_isMobile()) {
    const url ='https://mobile.zymls.com';
    window.location.href = url;
    return;
  }
  const routerList = ['/home','/brand','/store','/join','/information','/connect'];
  if(!routerList.includes(to.path)){
    next({ path: '/home' })
  }else{
    next();
  }
})
router.afterEach((to)=>{
  //跳转后始终滚动至顶部
  if(!to.query.block){
    window.scrollTo(0,0)
  }
})

function _isMobile () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js